import { all, call, fork, put, takeEvery, takeLatest } from 'redux-saga/effects'
import {
  SAVE_FILE_DISCOUNTS,
  GET_CLIENT_DISCOUNTS,
  SEARCH_DISCOUNT_ITEMS,
  SUBMIT_DISCOUNT_REQUEST,
  GET_AVAILABLE_TARGETS,
} from '../constants/ActionsTypes'
import {
  saveDiscounts,
  getClientDiscounts as getClientDiscountsAPI,
  submitDiscountRequest as submitDiscountRequestAPI,
  getAvailableTargets as getAvailableTargetsAPI,
} from '../api/Discounts'

import {
  saveDiscountsSuccess,
  saveDiscountsError,
  getClientDiscountsSuccess,
  getClientDiscountsError,
  searchDiscountItemsSuccess,
  searchDiscountItemsError,
  submitDiscountRequestSuccess,
  submitDiscountRequestError,
  getAvailableTargetsSuccess,
  getAvailableTargetsError,
} from '../actions/Discounts'
import { showMessages } from '../actions'

function* saveDiscountsRequest({ payload }) {
  try {
    yield call(saveDiscounts, payload)
    yield put(saveDiscountsSuccess())

    yield put(
      showMessages({
        summary: 'discounts.success_message',
        type: 'success',
        detail: payload.name,
      }),
    )
  } catch (err) {
    yield put(saveDiscountsError())
  }
}

function* getClientDiscountsRequest({ payload }) {
  try {
    // Handle both old format (just clientCode) and new format (object with clientCode and filters)
    const clientCode = typeof payload === 'string' ? payload : payload.clientCode
    const filters = typeof payload === 'object' ? payload.filters : {}

    const response = yield call(getClientDiscountsAPI, clientCode, filters)
    yield put(getClientDiscountsSuccess(response))
  } catch (err) {
    console.error('Error getting client discounts:', err)
    yield put(getClientDiscountsError(err.message || 'Error getting client discounts'))
  }
}

export function* saveDiscountsSaga() {
  yield takeEvery(SAVE_FILE_DISCOUNTS, saveDiscountsRequest)
}

export function* getClientDiscountsSaga() {
  yield takeEvery(GET_CLIENT_DISCOUNTS, getClientDiscountsRequest)
}

function* searchDiscountItemsRequest({ payload }) {
  try {
    const { query, type, clientCode } = payload

    const filters = {
      discountType: type,
      targetCode: query,
    }

    const response = yield call(getClientDiscountsAPI, clientCode, filters)
    const searchResults = response.data || []
    yield put(searchDiscountItemsSuccess(searchResults))
  } catch (err) {
    yield put(searchDiscountItemsError(err.message || 'Error searching discount items'))
  }
}

function* submitDiscountRequestRequest({ payload }) {
  try {
    const response = yield call(submitDiscountRequestAPI, payload)
    yield put(submitDiscountRequestSuccess(response))

    yield put(
      showMessages({
        summary: 'Discount requested successfully',
        type: 'success',
      }),
    )
  } catch (err) {
    yield put(submitDiscountRequestError(err.message || 'Error submitting discount request'))
  }
}

export function* searchDiscountItemsSaga() {
  yield takeLatest(SEARCH_DISCOUNT_ITEMS, searchDiscountItemsRequest)
}

function* getAvailableTargetsRequest({ payload }) {
  try {
    const { clientCode, type } = payload
    const response = yield call(getAvailableTargetsAPI, clientCode, type)
    yield put(getAvailableTargetsSuccess(response))
  } catch (err) {
    yield put(getAvailableTargetsError(err.message || 'Error getting available targets'))
  }
}

export function* submitDiscountRequestSaga() {
  yield takeEvery(SUBMIT_DISCOUNT_REQUEST, submitDiscountRequestRequest)
}

export function* getAvailableTargetsSaga() {
  yield takeLatest(GET_AVAILABLE_TARGETS, getAvailableTargetsRequest)
}

export default function* rootSaga() {
  yield all([
    fork(saveDiscountsSaga),
    fork(getClientDiscountsSaga),
    fork(searchDiscountItemsSaga),
    fork(submitDiscountRequestSaga),
    fork(getAvailableTargetsSaga),
  ])
}
